import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useState } from "react";
import { useNotify } from "../../providers/NotificationProvider";
import EditableRow from "./EditableRow";
import TotalsRow from "./TotalsRow";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function EditableTable(props) {
  const notify = useNotify();
  let { tableConfig, tableData, rowCreated, rowUpdated, rowDeleted, totalRow } =
    props;

  const widthUnits = tableConfig.columns.reduce(
    (acc, cv) => (cv.width || 1) + acc,
    0
  );
  tableConfig.columns = tableConfig.columns.map((config) => ({
    ...config,
    width: `${(100 / widthUnits) * (config.width || 1)}%`,
  }));

  const [rows, setRows] = useState(tableData);

  useEffect(() => {
    setRows(tableData.map((td) => ({ ...td, id: td[tableConfig.idField] })));
  }, [tableConfig.idField, tableData]);

  const classes = useStyles();
  const deleteRow = (rowData) => {
    rowDeleted(rowData.id);
  };
  const setRow = (rowData) => {
    if (!rowData.id) {
      rowCreated(rowData);
      return;
    }
    rowUpdated(rowData);
    setRows((prev) => {
      return prev.map((p) => {
        if (p.id === rowData.id) return rowData;
        return p;
      });
    });
  };

  const validateRow = useCallback(
    (row) => {
      const errorList = tableConfig.columns
        .filter((column) => !column.skipValidation)
        .filter((column) => !Boolean(row[column.field]))
        .map((column) => column.label);
      if (errorList.length === 0) return true;
      notify.show(`Missing Fields:  ${errorList.join(", ")}`, {
        severity: "error",
      });
      return false;
    },
    [notify, tableConfig]
  );

  return (
    <Table className={classes.table} aria-label="simple table" stickyHeader>
      <TableHead>
        <TableRow>
          {tableConfig.columns
            .filter((tc) => !tc.hidden)
            .map((tc) => (
              <TableCell
                key={tc.id}
                align={tc.align}
                style={{ width: tc.width }}
              >
                {tc.label}
              </TableCell>
            ))}
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <EditableRow
            validateRow={validateRow}
            setRow={setRow}
            deleteRow={deleteRow}
            row={row}
            tableConfig={tableConfig}
            hover={true}
            key={row[tableConfig.idField]}
          />
        ))}
        {tableConfig.disableEdit ? (
          <></>
        ) : (
          <EditableRow
            validateRow={validateRow}
            setRow={setRow}
            create={true}
            tableConfig={tableConfig}
            hover={true}
          />
        )}
        {totalRow && <TotalsRow tableConfig={tableConfig} rows={rows} />}
      </TableBody>
    </Table>
  );
}
